import { render } from "./RemoveModal.vue?vue&type=template&id=1b84b97d"
import script from "./RemoveModal.vue?vue&type=script&lang=js"
export * from "./RemoveModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/www.alb-bayern.de/bottle/www/apps/alb_development/frontend/mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/precipitation/RemoveModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1b84b97d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1b84b97d', __exports__)) {
    console.log('reload')
    api.reload('1b84b97d', __exports__)
  }
  
  module.hot.accept("./RemoveModal.vue?vue&type=template&id=1b84b97d", () => {
    console.log('re-render')
    api.rerender('1b84b97d', render)
  })

}


export default __exports__